
<template>

    <modal name="ConfirmDialog"
           :width="Width"
           :draggable="!IsMobile"
           @before-open="OnBeforeOpen"
           @before-close="OnBeforeClosed"
           @opened="OnOpened">

        <table class="ConfirmTable" :class="[ClassName]" ref="ConfirmDialog" cellspacing="0">
            <tr>
                <td class="Header">
                    {{Title}}
                    <t-button @click="OnCloseButtonClick" class="CloseDialogButton"
                              style="display:none">x</t-button>
                </td>
            </tr>
            <tr>
                <td class="Description" valign="middle">
                    <span v-html="Description "></span>
                </td>
            </tr>
            <tr class="ButtonList">
                <td class="ButtonList">
                    <t-button class="Button Confirm" @click="OnConfirmButtonClick">確認</t-button>
                    &nbsp;
                    <t-button class="Button Cancel" @click="OnCancelButtonClick">取消</t-button>
                </td>
            </tr>
        </table>

    </modal>


</template>

<script scoped>
    import Utility from "@/Common/Utility";


    export default {
        name: "ConfirmDialog",
        data() {
            return {
                Title: "",
                IsMobile: false,
                Description: "",
                ConfirmHandler: null,
                Width:"360",
                ClassName: "",
            }
        }
        ,
        props: ["value"],

        methods: {
            OnCloseButtonClick() {
                this.$modal.hide("ConfirmDialog");
            },

            OnConfirmButtonClick() {

                if (this.ConfirmHandler != null) {
                    this.ConfirmHandler({
                        id: this.id,
                        Confirm: true
                    });
                }

                this.$modal.hide("ConfirmDialog");
            },

            OnCancelButtonClick() {
                this.$modal.hide("ConfirmDialog");
            },

            OnBeforeOpen(arg) {
                let modalElement;


                if (arg.params.Title != null) {
                    this.Title = arg.params.Title;
                }
                else {
                    this.Title = "確認視窗";
                }

                if (arg.params.ClassName != null) {
                    this.ClassName = arg.params.ClassName;
                }

                if (arg.params.Width != null) {

                    setTimeout(
                        function () {
                            let vmModalElement;
                            let browserWidth;


                            browserWidth = Utility.GetBrowserWidth();

                            vmModalElement = Utility.GetParentElementBySelector(
                                this.$refs.ConfirmDialog,
                                ".vm--modal");

                            //vmModalElement.style.width = arg.params.Width + "px";
                            //vmModalElement.style.left = ((browserWidth - arg.params.Width) / 2) + "px";

                            this.Width = arg.params.Width;
                            this.$forceUpdate();
                        }.bind(this),
                        10
                    )
                }

                this.Description = arg.params.Description;
                this.ConfirmHandler = arg.params.ConfirmHandler;

                setTimeout(
                    () => {
                        document.querySelector(".vm--modal").style.height = "auto";
                    },
                    1
                );

            },


            OnBeforeClosed() {
                this.ClassName = null;
            },

            OnOpened() {

            }
        },

        computed: {

        },

        mounted() {
        },

        beforeMounted() {

        },

        created() {
            let argObject;


            this.IsMobile = Utility.IsMobile();

            argObject = Utility.GetSession("DialogArguments");
             
            if (argObject != null && argObject.Width != null) {
                this.Width = argObject.Width;
            }
            else if (this.IsMobile) {
                this.Width = 280;
            }

            Utility.ClearSession("DialogArguments");
        },

        watch: {
            value: function (newVal, oldVal) {

            }
        }


    }
</script>

<style>

    .ConfirmTable {
        width: 100%;
        height: 100%;
        min-width:280PX;
        border-left: 1px solid lightgray;
        border-right: 1px solid lightgray;
        background-color: transparent;
        font-family: 微軟正黑體,Microsoft JhengHei,Zawgyi-one;
    }

        .ConfirmTable .Description {
            background-color: rgba(255,255,255,0.8);
            white-space: pre-wrap;
            min-height: 100px;
            line-height: 20px;
            height: 90%;
            padding-left: 10px;
            padding-right: 10px;
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .ConfirmTable .Header {
            position: relative;
            text-align: center;
        }

    .CloseDialogButton {
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
        font-size: 15px;
        width: 28px;
        height: 28px;
        background-color: #F0F0F0;
        border: 1px solid #e0e0e0;
    }

    .ConfirmTable .Header {
 
    }

    .ConfirmTable.Delete .Header {
        background-color: #c7362e;
    }

    .ConfirmTable .Header,
    .ConfirmTable .ButtonList {
        min-height: 30px;
        font-size: 16px;
        font-weight: bold;
        padding: 5px;
        border-top: 1px solid lightgray;
        border-bottom: 1px solid lightgray;
        corsor: hand;
        cursor: pointer;
        padding: 10px;
    }

    .ConfirmTable .ButtonList {
        text-align: center;
    }


    .ConfirmTable.Delete .ButtonList .Button.Confirm {
        background-color: #c7362e;
    }

    .vm--modal {
        display: inline-block !important;
        width: auto !important;
        left:0px!important;
        max-width:900PX;
    }

    .v--modal-overlay[data-modal="search-modal"] .v--modal-box.wide {
        width: 95% !important;
        left: 2.5% !important;
    }


</style>
